import { applyMiddleware, compose, createStore } from 'redux'
import { apiMiddleware } from 'redux-api-middleware'
import { loadUser } from 'redux-oidc'

import { updateDataLayerUserId } from '@cinch/oxd-utils/analytics/src'

import userManager from '../utils/oidc/user-manager'
import createUserMiddleware from '../utils/oidc/user-middleware'
import analyticsMiddleware from './analytics-middleware'
import profileMiddleware from './profile-middleware'
import reducer from './reducer'
import searchMiddleware from './search-middleware'

const initialState = {}

const composeEnhancers = ((window as any) && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

const userMiddleware = createUserMiddleware(userManager)

const middleware = [apiMiddleware, userMiddleware, profileMiddleware, searchMiddleware, analyticsMiddleware]
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(...middleware))(createStore)
const store = createStoreWithMiddleware(reducer, initialState)

loadUser(store, userManager).then(updateDataLayerUserId).catch()

export default store
